import * as types from '../../../constants/ActionTypes';

export const setAcceptedHardCheck = acceptedHardCheck => ({
    type: types.SET_ACCEPTED_HARD_CHECK,
    acceptedHardCheck,
});

export const doHardCheck = params => ({
    type: types.SET_DO_HARD_CHECK,
    payload: new Promise((resolve, reject) => {
        // TODO: use service!
        setTimeout(() => {
            resolve({});
        }, 2000);
    }),
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/UnderwrittingSummary/underWrittingSummaryActions.js